/* eslint-disable react/forbid-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import UIkit from 'uikit'

import SubscriptionLocked from 'app/views/components/Subscription/SubscriptionLocked'
import Loader from 'app/views/components/Loader'

import {
  getAssessmentDetail,
  updateAssessment,
  updateTimeLeftCurrentQuestion,
  shiftCompletedAssessmentContent,
} from 'app/state/modules/assessments'
import CodeReview from 'app/views/containers/CodeReview'
import settings from 'settings'
import CountdownTimer from 'app/views/components/CountdownTimer'
import Icon from 'app/views/components/Icon'

const propTypes = {
  assessment: PropTypes.oneOfType([
    PropTypes.shape({
      requires_subscription: PropTypes.bool,
      is_expired: PropTypes.bool,
      license_out_of_scope: PropTypes.bool,
    }),
    PropTypes.string,
  ]),
}

const defaultProps = {
  assessment: {
    requires_subscription: true,
    is_expired: true,
    license_out_of_scope: true,
  },
}
class Assessment extends React.Component {
  constructor(props) {
    super(props)
    const { dontShowDetail } = this.props.location.state || {}
    this.state = {
      start: dontShowDetail,
      resetSandbox: false,
    }
    this.compare = this.compare.bind(this)
  }

  componentDidMount() {
    this.props.getAssessmentDetail(this.props.match.params.id)
  }

  compare(a, b) {
    if (a.name < b.name) {
      return -1
    }
    if (a.name > b.name) {
      return 1
    }
    return 0
  }

  renderStartedCounter() {
    if (this.props.assessment.started && this.props.assessment.content.length > 0) {
      if (this.props.assessment.content[0].startedAt && typeof this.props.assessment.content[0].timeLeft === 'number') {
        return (
          <CountdownTimer
            onTick={this.props.updateTimeLeftCurrentQuestion}
            className="uk-padding-small"
            time={this.props.assessment.content[0].timeLeft}
            id="countdown-assessment-1"
            onComplete={() => {
              const firstContent = this.props.assessment.content[0]
              this.props.updateAssessment(
                this.props.match.params.id,
                firstContent.uuid,
                false,
                true,
              )
              this.props.shiftCompletedAssessmentContent()
            }}
          />
        )
      }
    }
    return null
  }

  renderIcons(languageName, frameworkName, width = 100, height = 100, tooltip = null) {
    const style = {
      width: '100%',
    }
    let path = '/static/images/frameworks/'
    switch (frameworkName) {
      case 'react':
        path = `${path}react.png`
        break
      case 'angular':
        path = `${path}angular.png`
        break
      case 'spring_boot':
        path = `${path}spring.png`
        break
      case 'node':
        path = `${path}nodejs.png`
        break
      case 'flask':
        path = `${path}flask.png`
        break
      case 'laravel':
        path = `${path}laravel.png`
        break
      case 'rails':
        path = `${path}rails.png`
        break
      case 'net_http':
        path = `${path}golang.png`
        break
      case 'core':
        if (languageName === 'php') {
          path = `${path}php.svg`
        } else {
          path = `${path}dotnetccore.png`
        }
        break
      default:
        path = null
        break
    }
    return (
      <div
        style={{
          width,
          height,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginLeft: 20,
          marginRight: 20,
        }}
        uk-tooltip={tooltip ? settings.frameworks[tooltip] : null}
      >
        <img
          src={path}
          alt={frameworkName}
          style={style}
        />
      </div>
    )
  }

  renderMessage() {
    const { assessment } = this.props
    if (assessment.content.length === 0) {
      return 'You have completed the assessment. Talk to your administrator for the results.'
    }
    if (assessment.content[0].startedAt && typeof assessment.content[0].timeLeft === 'number') {
      return 'You have already started this assessment and the question you are currently on has a time limit. The time is still running. Hurry!'
    }
    if (assessment.content[0].startedAt || assessment.started) {
      return 'You have already started this assessment but there isn\'t limit time on the current question you are in.'
    }
    return 'You will be assessed on speed as well as accuracy, so please make sure you have time to sit down to go through the full assessment. We recommend blocking about 1 hour.'
  }

  renderLanguages() {
    let languages = []
    if (!Array.isArray(this.props.assessment.metadata.language)) {
      languages = [this.props.assessment.metadata.language]
    } else {
      languages = this.props.assessment.metadata.language
    }
    return languages.sort(this.compare).map((l) => (
      <li
        key={l.name}
        className="uk-flex uk-flex-row uk-flex-middle uk-flex-left"
      >
        <i
          className={`devicon-${settings.engineIcons[l.name]}-plain colored uk-margin-right`}
          style={{ fontSize: 30 }}
          title={l.name}
        />
        {`${settings.engines[l.name]}${l.version ? ` v${l.version}` : ''}`}
      </li>
    ))
  }

  renderContentType() {

    return this.props.content.map(({ language, framework }) => (
      <li key={`${language}-${framework}`} className="uk-flex uk-flex-row uk-flex-left uk-flex-middle">
        <div className="uk-flex uk-flex-left" style={{ width: 200 }}>
          <i
            className={`devicon-${settings.engineIcons[language]}-plain colored uk-margin-right`}
            style={{ fontSize: 30 }}
            title={language}
          />
          {`${settings.engines[language]} `}
        </div>
        <div className="uk-flex uk-flex-left" style={{ width: 200 }}>
          {this.renderIcons(language, framework, 30, 30)}
          {`${settings.frameworks[framework]}`}
        </div>
      </li>
    ))
  }

  render() {
    const { assessment } = this.props
    if (assessment === 'loading' || this.props.license === null) {
      return <Loader visible />
    }
    if ((assessment.requires_subscription === true && this.props.license === false)
      || (assessment.requires_subscription === true && assessment.license_out_of_scope)
      || (assessment.requires_subscription === true && assessment.is_expired)
      || (typeof assessment.total_score !== 'number' && assessment.free_completed >= assessment.max_free_users)
    ) {
      return (
        <SubscriptionLocked
          maxFreeAssessmentUsersReached={this.props.license === false && assessment.free_completed >= assessment.max_free_users && typeof assessment.total_score !== 'number'}
          maxFreeUsers={assessment.max_free_users}
          isExpired={assessment.is_expired}
          licenseOutOfScope={this.props.license === false ? false : assessment.license_out_of_scope}
          contentType={assessment.content_type}
        />
      )
    }
    if (!this.state.start) {
      return (
        <div
          className="uk-width-1-1 uk-height-1-1 uk-background-default uk-padding-large uk-flex uk-flex-column uk-flex-center uk-flex-middle"
        >
          <h1
            className="uk-margin-remove"
          >
            <u>
              {assessment.title || 'Assessment'}
            </u>
          </h1>
          {!assessment.locked || this.props.assessment.content.length > 0 ? (
            <h3
              style={{ marginTop: 20 }}
            >
              {assessment.content.length === 0 ? `Score: ${assessment.total_score} / ${assessment.max_score} points.` : `${this.props.assessment.content.length} Questions left`}
            </h3>
          )
            : (
              <h3>
                <Icon
                  name="lock"
                  onClick={() => {
                    UIkit.modal.dialog(`<p class="uk-text-muted uk-modal-body uk-text-center">
                   <br/>
                   <i class="ri-lock-line ri-2x"></i>
                   <br/>
                   Contact your manager or contact us for more information about how get access to your assessment score.
                 </p>`)
                  }}
                  style={{
                    cursor: 'pointer',
                  }}
                />
              </h3>
            )}
          {(assessment.description || assessment.metadata.app) ? (
            <p
              className="uk-text-center uk-width-1-2 uk-text-italic uk-text-emphasis"
            >
              {assessment.description || settings.appsDescriptions[assessment.metadata.app]}
            </p>
          ) : null}
          <div
            data-uk-grid=""
            className="uk-align-center"
            uk-height-match=".same-height"
          >
            <div className="uk-padding-remove">
              <ul className="uk-list uk-list-disc uk-list-muted uk-text-left">
                {this.renderContentType()}
              </ul>
            </div>
          </div>
          <p
            className="uk-width-1-3 uk-text-center uk-text-primary"
          >
            {this.renderMessage()}
          </p>
          {this.renderStartedCounter()}
          {
            this.props.assessment.content.length > 0 && (
              <button
                type="button"
                className="uk-button uk-button-primary"
                onClick={() => {
                  if (assessment.content.length > 0) {
                    this.props.history.push({
                      pathname: this.props.location.pathname,
                      state: {
                        dontShowDetail: true,
                      },
                    })
                    this.setState({
                      start: true,
                      resetSandbox: true,
                    })
                  }
                }}
              >
                {this.props.assessment.started ? 'Continue Assessment' : 'Start Assessment'}
              </button>
            )
          }
        </div>
      )
    }
    return (
      <CodeReview
        resetOnStart={this.state.resetSandbox}
        assessment={this.props.assessment}
      />
    )
  }
}

Assessment.propTypes = propTypes
Assessment.defaultProps = defaultProps

const mapStateToProps = (state) => ({
  license: state.hacker.license,
  assessment: state.assessments.assessmentDetail,
  content: Object.values((state.assessments.assessmentDetail.content_list || []).reduce((prev, curr) => {
    prev[`${curr.metadata.language.name}-${curr.metadata.framework.name}`] = {
      language: curr.metadata.language.name,
      framework: curr.metadata.framework.name,
    }
    return prev
  }, {})),
})

export default withRouter(connect(mapStateToProps, {
  getAssessmentDetail,
  updateAssessment,
  updateTimeLeftCurrentQuestion,
  shiftCompletedAssessmentContent,
})(Assessment))
